import { h } from '@stencil/core/internal/client';

function getAsChild([asElement, asProps], children, defaultProps) {
    const _defaultProps = defaultProps ? defaultProps[asElement] : undefined;
    const passProps = { ..._defaultProps, ...asProps };
    return h(asElement, passProps, children);
}

export { getAsChild as g };

//# sourceMappingURL=index9.js.map